import vink from '../img/vinky_1.png';
import bren from '../img/brendon_1.png';
import shig from '../img/shigs_1.png';

const people = [
  {
    name: 'Shigs',
    role: 'Character Designer @ Netflix',
    imageUrl: shig,
    bio: "Favorite NFTs: CrypToadz",
    bio2: "Coin picks for 2022: NFTs only (toadz)",
    discordUrl: 'https://discord.com/users/Shigs#4088'
  },
  {
    name: 'BrendonJacobs',
    role: 'Software Engineer @ Amazon',
    imageUrl: bren,
    bio: 'Favorite NFTs: Cryptopunks, Chain Runners, NFT Worlds',
    bio2: 
      'Coin picks for 2022: RON, RON, RON',
    discordUrl: 'https://discord.com/users/BrendonJacobs#1557'
  },
  {
    name: 'Vinky',
    role: 'Operations @ Goldshell Miners',
    imageUrl: vink,
    bio:
      'Favorite NFTs: Cyberkongz, Axie Infinity, Defi Kingdoms, HNS domains',
    bio2: 
      'Coin picks for 2022: JEWEL, FTM, STX',
    discordUrl: 'https://discord.com/users/vinky#0012',
    linkedinUrl: '#',
  },
  // More people...
]

export function Team() {
  return (
    <div id="team" className="">
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
      <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl nekored text-center my-8">The Team</h2>

        <div className="space-y-12 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0">
          {/* <div className="space-y-5 sm:space-y-4">
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl teal">The Team</h2>
            <p className="text-xl text-gray-500 teal">
            
            </p>
          </div> */}
          <div className="lg:col-span-3">
            <ul
              role="list"
              className="space-y-12 sm:grid sm:grid-cols-3 sm:gap-x-6 sm:gap-y-12 sm:space-y-0 lg:gap-x-8"
            >
              {people.map((person) => (
                <li className="nekored text-xl text-center" key={person.name}>
                  <div className="space-y-4">
                    <div className="aspect-w-3 aspect-h-2 ">
                      <img className="object-cover mx-auto w-64 h-64 shadow-lg rounded-full" src={person.imageUrl} alt="" />
                    </div>
                    <div className="text-lg leading-6 font-bold space-y-1">
                      <h3>{person.name}</h3>
                      <p className="coffee text-center">{person.role}</p>
                    </div>
                    <div className="text-lg">
                      <p className="coffee text-center">{person.bio}</p>
                    </div>
                    <div className="text-lg">
                      <p className="coffee text-center">{person.bio2}</p>
                    </div>

                    <ul role="list" className="flex space-x-5 w-8 mx-auto">
                      <li>
                        <a target="_blank" href={person.discordUrl} className="coffee coffee-link">
                          <span className="sr-only">Discord</span>
                            <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.317 2.36985C18.761 1.65561 17.119 1.1463 15.4319 0.854651C15.4166 0.851792 15.4007 0.853838 15.3867 0.860499C15.3726 0.86716 15.3609 0.878096 15.3534 0.891751C15.1424 1.26705 14.9087 1.75655 14.7451 2.14125C12.9004 1.86505 11.0651 1.86505 9.2583 2.14125C9.0947 1.74795 8.8525 1.26705 8.6406 0.891751C8.63276 0.878407 8.62107 0.867739 8.60706 0.861138C8.59306 0.854538 8.57739 0.852312 8.5621 0.854751C6.87488 1.14572 5.2327 1.65499 3.6769 2.36975C3.66359 2.37544 3.65238 2.38512 3.6448 2.39745C0.533404 7.04585 -0.318996 11.58 0.099204 16.0579C0.100386 16.0688 0.103757 16.0794 0.109116 16.0891C0.114476 16.0987 0.121714 16.1072 0.130404 16.1139C2.1832 17.6215 4.1717 18.5368 6.1233 19.1434C6.13848 19.1479 6.15468 19.1477 6.16972 19.1427C6.18477 19.1378 6.19795 19.1284 6.2075 19.1158C6.6691 18.4854 7.0806 17.8206 7.4335 17.1216C7.43835 17.112 7.44112 17.1015 7.44163 17.0908C7.44213 17.0801 7.44036 17.0693 7.43643 17.0594C7.4325 17.0494 7.4265 17.0403 7.41883 17.0328C7.41115 17.0253 7.40198 17.0196 7.3919 17.0159C6.7391 16.7683 6.1176 16.4664 5.5197 16.1236C5.5088 16.1171 5.49964 16.1082 5.49304 16.0974C5.48643 16.0866 5.48258 16.0744 5.48183 16.0617C5.48108 16.0491 5.48345 16.0365 5.48873 16.025C5.49401 16.0135 5.50204 16.0035 5.5121 15.9959C5.6379 15.9016 5.7638 15.8035 5.8839 15.7044C5.89458 15.6956 5.9075 15.69 5.92121 15.6881C5.93492 15.6863 5.94887 15.6883 5.9615 15.6939C9.8893 17.4872 14.1415 17.4872 18.0229 15.6939C18.0355 15.6879 18.0496 15.6856 18.0635 15.6873C18.0774 15.689 18.0906 15.6946 18.1014 15.7035C18.2216 15.8025 18.3474 15.9016 18.4742 15.9959C18.4843 16.0034 18.4924 16.0134 18.4977 16.0248C18.5031 16.0362 18.5055 16.0488 18.5049 16.0614C18.5042 16.074 18.5005 16.0863 18.494 16.0971C18.4875 16.1079 18.4784 16.117 18.4676 16.1235C17.8695 16.4728 17.2429 16.771 16.5946 17.0149C16.5845 17.0187 16.5754 17.0246 16.5678 17.0323C16.5602 17.0399 16.5542 17.049 16.5504 17.0591C16.5466 17.0692 16.5449 17.0799 16.5455 17.0907C16.5461 17.1015 16.549 17.112 16.5539 17.1216C16.9143 17.8196 17.3258 18.4844 17.7789 19.1148C17.7882 19.1278 17.8013 19.1375 17.8164 19.1427C17.8315 19.1478 17.8478 19.148 17.8631 19.1434C19.8241 18.5366 21.8126 17.6215 23.8654 16.1139C23.8742 16.1075 23.8816 16.0992 23.887 16.0897C23.8924 16.0802 23.8957 16.0696 23.8967 16.0588C24.3971 10.8818 23.0585 6.38485 20.3482 2.39835C20.3416 2.3854 20.3305 2.37525 20.317 2.36975V2.36985ZM8.02 13.3313C6.8375 13.3313 5.8631 12.2456 5.8631 10.9123C5.8631 9.57905 6.8186 8.49335 8.0201 8.49335C9.2309 8.49335 10.1958 9.58855 10.1769 10.9124C10.1769 12.2456 9.2214 13.3313 8.02 13.3313ZM15.9948 13.3313C14.8123 13.3313 13.8379 12.2456 13.8379 10.9123C13.8379 9.57905 14.7933 8.49335 15.9948 8.49335C17.2056 8.49335 18.1705 9.58855 18.1516 10.9124C18.1516 12.2456 17.2056 13.3313 15.9948 13.3313Z" fill="currentColor"></path></svg>
                        </a>
                      </li>
                      { person.twitterUrl && <li>
                        <a target="_blank" href={person.twitterUrl} className="text-gray-400 hover:text-gray-500">
                          <span className="sr-only">Twitter</span>
                          <svg className="w-5 h-5" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                          </svg>
                        </a>
                      </li>}
                    </ul>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
